module.exports = __webpack_public_path__ + "img/jascap_logo.105bfc00.jpg";